import React from 'react';
import ReactDOM, { unmountComponentAtNode } from 'react-dom';

import EntryWrapper from 'src/EntryWrapper';
import BannerRecipe from '../components/bannerRecipe';
import SelectionInformer from "../components/bannerRecipe/SelectionInformer";

const onRender = () => {
  const rootElement = document.getElementById('banner-recipe');

  if (rootElement) {
    unmountComponentAtNode(rootElement);

    const isRecipeDeliveryAllowed = rootElement.getAttribute('data-is-recipe-delivery-allowed') === 'true' || false;
    const isAcceptedERecipe = rootElement.getAttribute('data-accepted-erecipe') === 'true' || false;
    const showInformer = rootElement.getAttribute('data-show-informer') === 'true' || false;

    if ((!isRecipeDeliveryAllowed || isAcceptedERecipe) && !showInformer) return null;

    ReactDOM.render(
      <EntryWrapper>
        {showInformer ? <SelectionInformer /> : <BannerRecipe />}
      </EntryWrapper>,
      rootElement
    );
  }
};

const onRefreshRender = () => {
  onRender();
};

onRender();

document.addEventListener('bannerRecipeIsRender', onRefreshRender);
